module.exports = "<header class=\"app-header\">\n\t<app-header>Loading...</app-header>\n</header>\n<div class=\"component-sidenav\">\n\t<div class=\"content-area\">\n\t\t<md-sidenav-container>\n\t\t\t<md-sidenav mode=\"side\" align=\"end\" [opened]=\"isSidebarOpen\">\n\t\t\t\t<app-task-panel></app-task-panel>\n\t    \t</md-sidenav>\n\t    \t<router-outlet></router-outlet>\n\t\t</md-sidenav-container>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 2177
// module chunks = 0